import styled from "styled-components/macro";
import { calculateRem } from "styles/mixins/mixins";

import type { ThemeProps } from "models/styles/theme";
import { Heading6 } from "styles/elements/Headings";
import { Box, CssClickableIcon, CssIcon } from "styles/helpers/layout";

export const StyledChapterOverview = styled(Box)<ThemeProps>`
  .accordion-content-body {
    display: grid;
    row-gap: 1rem;
  }
`;

export const StyledChapterTitle = styled(Heading6)`
  font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.bold};
  color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  margin-bottom: 0;
`;

export const StyledProgressPercentage = styled.b<ThemeProps>`
  width: 2rem;
  display: inline-block;
  margin: 0 0.25rem 0 0.75rem;
  font-size: ${(props: ThemeProps) => props.theme.font.size._12};
`;

export const TopicButton = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 2rem;
  grid-template-rows: auto;
  gap: 0px 0px;
  height: ${calculateRem(40)};
  align-items: center;
  grid-template-areas: 'Name Level Actions';
  padding: 0 1.5rem 2rem 4rem;

  &:hover {
    cursor: pointer;
    background-color: ${(props: ThemeProps) => props.theme.palette.neutral._999};
  }

  &.disabled {
    color: ${(props: ThemeProps) => props.theme.palette.neutral._600};
    cursor: not-allowed;
    background-color: transparent;
  }
`;

export const CompletedIcon = styled(CssIcon)`
  color: ${(props: ThemeProps) => props.theme.palette.feedback.success._600};
`;

export const ActionIconButton = styled(CssClickableIcon)`
  padding: 0.5rem;
  color: ${(props: ThemeProps) => props.theme.palette.secondary.brand};

  :hover {
    color: ${(props: ThemeProps) => props.theme.palette.secondary._400};
  }
`;
